import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ThemeInfoModel } from '../Models/theme.model';
import { AuthService } from '../auth.service'
import { DashboardService } from 'app/dashboard/dashboard.service';

@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html', 
  styleUrls: ['./theme.component.scss']
})
export class ThemeComponent implements OnInit {
 
  primaryColor: string;
  fontsize: any = [];
  fontFamily: any = [];
  themedataobj: ThemeInfoModel = {};
  themeDataarray: any = [];
  CustomthemeDataarray: any = [];
  InsertCustomTheme: any = [];
  defaultThemeArray=[];
  CustomThemeArray=[];
  public customThermrobj: any = {};
  useDefaulttheme:boolean=false;

  constructor(public dialog: MatDialog, public authservice: AuthService,  public dashboardService: DashboardService) {
    this.defaultThemeArray=[];
    this.CustomThemeArray =[];
    //  this.getthemeConfig();
  }

  ngOnInit(): void {
    this.fontsize = ['9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '21px', '22px']
    this.fontFamily = ['inherit ,Times', 'Times,serif', 'Lato,system-ui', 'inherit,serif', 'serif,system-ui', 'inherit,serif,system-ui']
    this.dashboardService.open_loader_Dialog();
   
    setInterval(() => {  
      this.dashboardService.loaderComp.close();
    }, 2000);

  }

    getthemeConfig() {
  //     = data;
  this.defaultThemeArray=this.authservice.defaultThemeAray;
      console.log(this.authservice.defaultThemeAray)
  //     .subscribe(data => {
  //     this.defaultThemeArray = data;
  //     // this.themeDataarray= data;
  //     console.log('default theme array', this.defaultThemeArray );
  //     this.authservice.checkThemeStatus =1;  
  //     this.setdefailthem();
  //  });

 
 


  }
  getCustomthemeDetails(){
    this.authservice.checkThemeStatus =2;
   
    if(this.authservice.Loggeduser.userid){
      this.authservice.getcustomthemedata(this.authservice.Loggeduser.userid)
      // .subscribe(data=>{
      //   console.log('custom api data',data)
      //   // this.CustomThemeArray = data;
      //    this.CustomthemeDataarray = data;
      //   console.log('custom',this.CustomthemeDataarray);
      //   this.authservice.checkThemeStatus = 2;
      //   this.setcusthemeforme();
       
      // });
    }
  }

 
  onthemesChange(){
    console.log(this.authservice.checkThemeStatus);
    if(this.authservice.checkThemeStatus === 1){
     this.setdefailthem();
    }
    else{
      this.setcusthemeforme();
    }
  }

  
  setdefailthem() {
    this.InsertCustomTheme = [];
    this.authservice.checkThemeStatus =1;
    var bodydata: any = [];
    var headedata: any = [];
    var pagesdata: any = [];
    var inputdata: any = [];
    var tabledata: any = [];
    var sideBarData: any = [];
    var iconsData: any = [];
   console.log('defaultData',this.defaultThemeArray);

    if (this.defaultThemeArray.length > 0) {
      console.log('default with db');
      for (let i = 0; i < this.defaultThemeArray.length; i++) {
        if(this.defaultThemeArray[i].theme == "Default"){
        if (this.defaultThemeArray[i].tag == "body") {
          bodydata.push(this.defaultThemeArray[i]);
         
          for (let j = 0; j < bodydata.length; j++) {
            if (bodydata[j].property == "txtcolor") {
              this.changebodycolore(bodydata[j].value);
            }
            if (bodydata[j].property == "bgcolor") {
              this.changebodybackgroundcolore(bodydata[j].value);
              console.log('set default in if bodybg')

            }

            if (bodydata[j].property == "fontsize") {
              this.changebodybackgroundfontsize(bodydata[j].value);

            }
            if (bodydata[j].property == "fontfamily") {
              this.changebodybackgroundfontfamily(bodydata[j].value);

            }

          }
        }
        if (this.defaultThemeArray[i].tag == "header") {
          headedata.push(this.defaultThemeArray[i]);
          // console.log('theme-"header"', headedata);
          for (let j = 0; j < headedata.length; j++) {
            // console.log('body-data',headedata[j])
            if (headedata[j].property == "bgcolor") {
              this.setheaderbackgroundcolor(headedata[j].value);
              console.log('set default in if headerbg')

            }
            if (headedata[j].property == "txtcolor") {
              this.setheaderlistcolor(headedata[j].value);

            }

          }


        }
        if (this.defaultThemeArray[i].tag == "page") {
          pagesdata.push(this.defaultThemeArray[i]);
          // console.log('theme-"pages"', pagesdata);

          for (let j = 0; j < pagesdata.length; j++) {
            // console.log('body-data',pagesdata[j])
            if (pagesdata[j].property == "txtcolor") {
              this.changePageHeadingColor(pagesdata[j].value);

            }
            if (pagesdata[j].property == "bgcolor") {
              this.changePagebackgroundColor(pagesdata[j].value);
              console.log('set default in if pagebg')

            }

            if (pagesdata[j].property == "fontsize") {
              this.changePagefontsize(pagesdata[j].value);

            }
            if (pagesdata[j].property == "fontfamily") {
              this.changePagefontfamily(pagesdata[j].value);

            }
            if (pagesdata[j].property == "primarybuttoncolor") {
              this.changeButtonsColor(pagesdata[j].value);

            }
            if (pagesdata[j].property == "secondarybuttoncolor") {
              this.changeSecondryButtonsColor(pagesdata[j].value);
            }
          }
        }
        if (this.defaultThemeArray[i].tag == "input") {
          inputdata.push(this.defaultThemeArray[i]);

          for (let j = 0; j < inputdata.length; j++) {
            if (inputdata[j].property == "bgcolor") {
              this.inputfieldbgcolor(inputdata[j].value);
            }
          }

        }
        if (this.defaultThemeArray[i].tag == "table") {
          tabledata.push(this.defaultThemeArray[i]);
          // console.log('table-data',tabledata)
          for (let j = 0; j < tabledata.length; j++) {
            if (tabledata[j].property == "headerbgcolor") {
              this.settableheadingbackgeound(tabledata[j].value);

            }
            if (tabledata[j].property == "databgcolor") {
              this.settabledatabackgeound(tabledata[j].value);

            }

            if (tabledata[j].property == "headertxtcolor") {
              this.settableheadingcolor(tabledata[j].value);
            }
            if (tabledata[j].property == "datatxtcolor") {
              this.settabledatacolor(tabledata[j].value);
            }

            if (tabledata[j].property == "headerfontsize") {
              this.settablehaederfont(tabledata[j].value);

            }
            if (tabledata[j].property == "datafontsize") {
              this.settabledatafont(tabledata[j].value);

            }

          }
        }
        if (this.defaultThemeArray[i].tag == "sidebar") {
          sideBarData.push(this.defaultThemeArray[i]);
          for (let j = 0; j < sideBarData.length; j++) {
            if (sideBarData[j].property == "txtcolor") {
              this.setsidebartxtcolor(sideBarData[j].value);

            }
            if (sideBarData[j].property == "bgcolor") {
              this.setiSidebarbgcolor(sideBarData[j].value);

            }
          }
        }
        if (this.defaultThemeArray[i].tag == "icons") {
          iconsData.push(this.defaultThemeArray[i]);
          for (let j = 0; j < iconsData.length; j++) {
            if (iconsData[j].property == "txtcolor") {
              this.seticonstxtcolor(iconsData[j].value);

            }
            if (iconsData[j].property == "bgcolor") {
              this.seticonsbgcolor(iconsData[j].value);

            }
          }
        }
      }

      }
      console.log('themeobj',this.themedataobj)
   
    }
    else {
      this.authservice.checkThemeStatus =0;
      console.log('set default in else without db')
      this.seticonsbgcolor('#50bbbb');
      this.seticonstxtcolor('#ffffff');
      this.setiSidebarbgcolor('#50bbbb');
       this.setsidebartxtcolor('#ffffff');
      this.settabledatafont('12px');
      this.settablehaederfont('12px');
      this.settabledatacolor('#000000');
      this.settableheadingcolor('#ffffff');
      this.settabledatabackgeound('#ffffff');
      this.settableheadingbackgeound('#50bbbb');
      this.inputfieldbgcolor('#26a8ab');
      this.changeSecondryButtonsColor('#f8857c');
      this.changeButtonsColor('#50bbbb');
      this.changePagefontfamily('inherit,serif,system-ui');
      this.changePagefontsize('15px');
      this.changePagebackgroundColor('#fffff');
      this.changePageHeadingColor('#000000');
      this.setheaderlistcolor('#ffffff');
      this.setheaderbackgroundcolor('#50bbbb');
      this.changebodybackgroundfontfamily('inherit,serif,system-ui');
      this.changebodybackgroundfontsize('18px');
      this.changebodybackgroundcolore('#ffffff');
      this.changebodycolore('#26a8ab');
     }

}

setcusthemeforme() {
  this.InsertCustomTheme = [];
  this.authservice.checkThemeStatus =2;
  var bodydata: any = [];
  var headedata: any = [];
  var pagesdata: any = [];
  var inputdata: any = [];
  var tabledata: any = [];
  var sideBarData: any = [];
  var iconsData: any = [];
 
  console.log('customData',this.CustomthemeDataarray);
  if (this.CustomthemeDataarray.length > 0) {
    console.log('custom with db');
    for (let i = 0; i < this.CustomthemeDataarray.length; i++) {
      if(this.CustomthemeDataarray[i].theme == "Custom"){
      if (this.CustomthemeDataarray[i].tag == "body") {
        bodydata.push(this.CustomthemeDataarray[i]);
       
        for (let j = 0; j < bodydata.length; j++) {
          if (bodydata[j].property == "txtcolor") {
            this.changebodycolore(bodydata[j].value);
          }
          if (bodydata[j].property == "bgcolor") {
            this.changebodybackgroundcolore(bodydata[j].value);
            console.log('set default in if bodybg')

          }

          if (bodydata[j].property == "fontsize") {
            this.changebodybackgroundfontsize(bodydata[j].value);

          }
          if (bodydata[j].property == "fontfamily") {
            this.changebodybackgroundfontfamily(bodydata[j].value);

          }

        }
      }
      if (this.CustomthemeDataarray[i].tag == "header") {
        headedata.push(this.CustomthemeDataarray[i]);
        // console.log('theme-"header"', headedata);
        for (let j = 0; j < headedata.length; j++) {
          // console.log('body-data',headedata[j])
          if (headedata[j].property == "bgcolor") {
            this.setheaderbackgroundcolor(headedata[j].value);
            console.log('set default in if headerbg')

          }
          if (headedata[j].property == "txtcolor") {
            this.setheaderlistcolor(headedata[j].value);

          }

        }


      }
      if (this.CustomthemeDataarray[i].tag == "page") {
        pagesdata.push(this.CustomthemeDataarray[i]);
        // console.log('theme-"pages"', pagesdata);

        for (let j = 0; j < pagesdata.length; j++) {
          // console.log('body-data',pagesdata[j])
          if (pagesdata[j].property == "txtcolor") {
            this.changePageHeadingColor(pagesdata[j].value);

          }
          if (pagesdata[j].property == "bgcolor") {
            this.changePagebackgroundColor(pagesdata[j].value);
            console.log('set default in if pagebg')

          }

          if (pagesdata[j].property == "fontsize") {
            this.changePagefontsize(pagesdata[j].value);

          }
          if (pagesdata[j].property == "fontfamily") {
            this.changePagefontfamily(pagesdata[j].value);

          }
          if (pagesdata[j].property == "primarybuttoncolor") {
            this.changeButtonsColor(pagesdata[j].value);

          }
          if (pagesdata[j].property == "secondarybuttoncolor") {
            this.changeSecondryButtonsColor(pagesdata[j].value);
          }
        }
      }
      if (this.CustomthemeDataarray[i].tag == "input") {
        inputdata.push(this.CustomthemeDataarray[i]);

        for (let j = 0; j < inputdata.length; j++) {
          if (inputdata[j].property == "bgcolor") {
            this.inputfieldbgcolor(inputdata[j].value);
          }
        }

      }
      if (this.CustomthemeDataarray[i].tag == "table") {
        tabledata.push(this.CustomthemeDataarray[i]);
        // console.log('table-data',tabledata)
        for (let j = 0; j < tabledata.length; j++) {
          if (tabledata[j].property == "headerbgcolor") {
            this.settableheadingbackgeound(tabledata[j].value);

          }
          if (tabledata[j].property == "databgcolor") {
            this.settabledatabackgeound(tabledata[j].value);

          }

          if (tabledata[j].property == "headertxtcolor") {
            this.settableheadingcolor(tabledata[j].value);
          }
          if (tabledata[j].property == "datatxtcolor") {
            this.settabledatacolor(tabledata[j].value);
          }

          if (tabledata[j].property == "headerfontsize") {
            this.settablehaederfont(tabledata[j].value);

          }
          if (tabledata[j].property == "datafontsize") {
            this.settabledatafont(tabledata[j].value);

          }

        }
      }
      if (this.CustomthemeDataarray[i].tag == "sidebar") {
        sideBarData.push(this.CustomthemeDataarray[i]);
        for (let j = 0; j < sideBarData.length; j++) {
          if (sideBarData[j].property == "txtcolor") {
            this.setsidebartxtcolor(sideBarData[j].value);

          }
          if (sideBarData[j].property == "bgcolor") {
            this.setiSidebarbgcolor(sideBarData[j].value);

          }
        }
      }
      if (this.CustomthemeDataarray[i].tag == "icons") {
        iconsData.push(this.CustomthemeDataarray[i]);
        for (let j = 0; j < iconsData.length; j++) {
          if (iconsData[j].property == "txtcolor") {
            this.seticonstxtcolor(iconsData[j].value);

          }
          if (iconsData[j].property == "bgcolor") {
            this.seticonsbgcolor(iconsData[j].value);

          }
        }
      }
    }

    }
    console.log('themeobj',this.themedataobj)
 
  }
  else{
    this.setdefailthem();
  }
  

}


 


 changebodybackgroundcolore(color) {
       document.documentElement.style.setProperty('--bodybackground-colour', color);
      this.themedataobj.bodybgcolor = color;
      console.log('themeType',this.authservice.checkThemeStatus,this.CustomthemeDataarray)
        if(this.authservice.checkThemeStatus == 2){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
          if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
          if (this.CustomthemeDataarray[a].tag == 'body' && this.CustomthemeDataarray[a].property == 'bgcolor') {
             this.CustomthemeDataarray[a].value = color;
            this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
            console.log('updating1',  this.InsertCustomTheme);
           }
          }
          else{
            console.log(this.authservice.Loggeduser.userid)
            if (this.CustomthemeDataarray[a].tag == 'body' && this.CustomthemeDataarray[a].property == 'bgcolor') {
             this.CustomthemeDataarray[a].pK_TranId = 0;
             this.CustomthemeDataarray[a].theme = 'Custom';
             this.CustomthemeDataarray[a].value = color;
             this.CustomthemeDataarray[a].fk_UserID = this.authservice.Loggeduser.userid;
             this.CustomthemeDataarray[a].fK_CreatedById = this.authservice.Loggeduser.userid;
             this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
             console.log('insert1',  this.InsertCustomTheme);
            }

          }

        }

       }
       else if(this.authservice.checkThemeStatus == 0){
        var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "body",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);

       }
    
    }

    changebodycolore(color:any) {
      document.documentElement.style.setProperty('--bodycolor-value', color);
      this.themedataobj.bodytxtcolor = color;
        if(this.authservice.checkThemeStatus == 2){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
          if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
            if (this.CustomthemeDataarray[a].tag == 'body' && this.CustomthemeDataarray[a].property == 'txtcolor') {
            this.CustomthemeDataarray[a].value = color;
              this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
             console.log('updating2',  this.InsertCustomTheme);
             }
            }
          else {
            if (this.CustomthemeDataarray[a].tag == 'body' && this.CustomthemeDataarray[a].property == 'txtcolor') {
             this.CustomthemeDataarray[a].pK_TranId = 0;
             this.CustomthemeDataarray[a].value = color;
             this.CustomthemeDataarray[a].fk_UserID = this.authservice.Loggeduser.userid;
             this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
             this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
             console.log('insert2' ,  this.InsertCustomTheme);
            }

          }
      }
      }
       else if(this.authservice.checkThemeStatus == 0){
        var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "body",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);

       }

  
    }


 
    
  setheaderbackgroundcolor(color) {
    document.documentElement.style.setProperty('--loginheadbg-colour', color);
    this.themedataobj.headerbgcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        // debugger;
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'header' && this.CustomthemeDataarray[a].property == 'bgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
              for (let t = 0; t <  this.themeDataarray.length; t++) {
                if ( this.themeDataarray[t].tag == 'header' &&  this.themeDataarray[t].property == 'bgcolor') {
                          this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                          this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                          this.themeDataarray[t].pK_TranId = 0;
                         this.themeDataarray[t].tag = "header";
                         this.themeDataarray[t].theme = "custom";
                         this.themeDataarray[t].property = 'bgcolor';
                         this.themeDataarray[t].value = color;
                       this.InsertCustomTheme.push( this.themeDataarray[t]);
                       console.log('insering');
                     }
                  }
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
            if ( this.themeDataarray[t].tag == 'header' &&  this.themeDataarray[t].property == 'bgcolor') {
                      this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                      this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                      this.themeDataarray[t].pK_TranId = 0;
                     this.themeDataarray[t].tag = "header";
                     this.themeDataarray[t].theme = "custom";
                     this.themeDataarray[t].property = 'bgcolor';
                     this.themeDataarray[t].value = color;
                   this.InsertCustomTheme.push( this.themeDataarray[t]);
                   console.log('insering');
                 }
              }
       }
      
       }
       else {
        var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "header",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
       this.InsertCustomTheme.push(myobj);
      }

    }

  // setheaderbackgroundcolor(color) {
  //   document.documentElement.style.setProperty('--loginheadbg-colour', color);
  //   this.themedataobj.headerbgcolor = color;
  // if(this.themeDataarray.length >0){
  //   this.themeDataarray.forEach(element => {
  //     if (element.fK_CreatedById == null) {
  //       if (element.tag == 'header' && element.property == 'bgcolor') {
  //         element.pK_TranId = 0;
  //         element.fK_CreatedById = this.authservice.Loggeduser.userid,
  //           element.fk_UserID = this.authservice.Loggeduser.userid,
  //           element.theme = "custom";
  //         element.property = 'bgcolor';
  //         element.value = color;
  //         this.InsertCustomTheme.push(element);
  //       }
  //     }
  //     else {
  //       if (element.tag == 'header' && element.property == 'bgcolor' && element.theme == "custom") {
  //         element.fK_CreatedById = this.authservice.Loggeduser.userid,

  //           element.property = 'bgcolor';
  //         element.value = color;
  //         this.InsertCustomTheme.push(element);
  //       }

  //     }
  //   });
  //    }
  //   else {
  //     var myobj = {
  //       "pK_TranId": 0,
  //       "theme": "Default",
  //       "fk_UserID": 1,
  //       "tag": "header",
  //       "property": "bgcolor",
  //       "value": color,
  //       "isActive": true,
  //       "fK_CreatedById": 1,
  //       "createDateTime": null
  //     }
  //    this.InsertCustomTheme.push(myobj);
  //   }
  //  // console.log(this.InsertCustomTheme);
  // }

  setheaderlistcolor(color) {
   
    document.documentElement.style.setProperty('--loginheadlist-colour', color);
    this.themedataobj.headertxtcolor = color;
     if (this.themeDataarray.length > 0){
    if(this.CustomthemeDataarray.length >0){
      for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
          if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
            if (this.CustomthemeDataarray[a].tag == 'header' && this.CustomthemeDataarray[a].property == 'txtcolor') {
             this.CustomthemeDataarray[a].value = color;
             this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
             this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
             console.log('updating');
            }
           }
           else{
 
              for (let t = 0; t <  this.themeDataarray.length; t++) {
                if (this.themeDataarray[t].tag == 'header' && this.themeDataarray[t].property == 'txtcolor') {
                      this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                      this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                      this.themeDataarray[t].pK_TranId = 0;
                     this.themeDataarray[t].tag = "header";
                     this.themeDataarray[t].theme = "custom";
                     this.themeDataarray[t].property = 'txtcolor';
                     this.themeDataarray[t].value = color;
                   this.InsertCustomTheme.push(this.themeDataarray[t]);
                   console.log('insering');
                }
                
              }
             
              
         }
        
         }
      }
     else{
      for (let t = 0; t <  this.themeDataarray.length; t++) {
        if (this.themeDataarray[t].tag == 'header' && this.themeDataarray[t].property == 'txtcolor') {
              this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
              this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
              this.themeDataarray[t].pK_TranId = 0;
             this.themeDataarray[t].tag = "header";
             this.themeDataarray[t].theme = "custom";
             this.themeDataarray[t].property = 'txtcolor';
             this.themeDataarray[t].value = color;
           this.InsertCustomTheme.push(this.themeDataarray[t]);
           console.log('insering');
        }
        
      }
            
     }
    
     }
    else {
     var myobj = {
        "pK_TranId": 0,
        "theme": "Default",
        "fk_UserID": 1,
        "tag": "header",
        "property": "txtcolor",
        "value": color,
        "isActive": true,
        "fK_CreatedById": 1,
        "createDateTime": null
      }
      this.InsertCustomTheme.push(myobj);
     }


  }

  changePagebackgroundColor(color) {
    document.documentElement.style.setProperty('--componetbackground-colour', color);
    this.themedataobj.pagebgcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'page' && this.CustomthemeDataarray[a].property == 'bgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'bgcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "page";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'bgcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'bgcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "page";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'bgcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "page",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }

   // console.log(this.InsertCustomTheme);
  }


  changePageHeadingColor(color) {
    document.documentElement.style.setProperty('--pageHeading-colour', color);
    this.themedataobj.pagetxtcolor = color
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'page' && this.CustomthemeDataarray[a].property == 'txtcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'txtcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "page";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'txtcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'txtcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "page";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'txtcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "page",
          "property": "txtcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }
}


  changePagemargin(color) {
    document.documentElement.style.setProperty('--compmargin-value', color);
    this.customThermrobj.theme = "custom";
    this.customThermrobj.tag = "page";
    this.customThermrobj.property = 'txtcolor';
    this.customThermrobj.value = color;
    this.InsertCustomTheme.push(this.customThermrobj);
   // console.log(this.InsertCustomTheme);
  }

  changePagePadding(color) {
    document.documentElement.style.setProperty('--compopadding-value', color);
  }
  changePageBodercolor(color) {
    document.documentElement.style.setProperty('--compboder-value', color);
  }

  changePagefontsize(color) {
    document.documentElement.style.setProperty('--compfontsize-value', color);
    this.themedataobj.pagefontsize = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'page' && this.CustomthemeDataarray[a].property == 'fontsize') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'fontsize') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "page";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'fontsize';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
                     
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'fontsize') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "page";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'fontsize';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "page",
          "property": "fontsize",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }

  }

  changePagefontfamily(color) {
    document.documentElement.style.setProperty('--compfontfamily-value', color);
    this.themedataobj.pagefontfamily = color;
 
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'page' && this.CustomthemeDataarray[a].property == 'fontfamily') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'fontfamily') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "page";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'fontfamily';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'fontfamily') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "page";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'fontfamily';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "page",
          "property": "fontfamily",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }

  changeButtonsColor(color) {
    document.documentElement.style.setProperty('--pageButton-colour', color);
    this.themedataobj.pagebtnone = color;

    
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'page' && this.CustomthemeDataarray[a].property == 'primarybuttoncolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'primarybuttoncolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "page";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'primarybuttoncolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'primarybuttoncolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "page";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'primarybuttoncolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "page",
          "property": "primarybuttoncolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }



  changeSecondryButtonsColor(color) {
    document.documentElement.style.setProperty('--pageButtoncancel-colour', color);
    this.themedataobj.pagebtntwo = color;

    
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'page' && this.CustomthemeDataarray[a].property == 'secondarybuttoncolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'secondarybuttoncolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "page";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'secondarybuttoncolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'page' && this.themeDataarray[t].property == 'secondarybuttoncolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "page";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'secondarybuttoncolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "page",
          "property": "secondarybuttoncolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }

  changelistHoverColor(color) {
    document.documentElement.style.setProperty('--listhover-colour', color);
  }

  changebodybackgroundfontsize(color) {
    document.documentElement.style.setProperty('--bodyfontsize-value', color);
    this.themedataobj.bodyfontsize = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'body' && this.CustomthemeDataarray[a].property == 'fontsize') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'body' && this.themeDataarray[t].property == 'fontsize') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "body";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'fontsize';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'body' && this.themeDataarray[t].property == 'fontsize') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "body";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'fontsize';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "body",
          "property": "fontsize",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }
 

  }
  changebodybackgroundfontfamily(color) {
    document.documentElement.style.setProperty('--bodyfontfamily-value', color);
    this.themedataobj.bodyfontfamily = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'body' && this.CustomthemeDataarray[a].property == 'fontfamily') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'body' && this.themeDataarray[t].property == 'fontfamily') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "body";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'fontfamily';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'body' && this.themeDataarray[t].property == 'fontfamily') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "body";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'fontfamily';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "body",
          "property": "fontfamily",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }

  inputfieldbgcolor(color) {
    document.documentElement.style.setProperty('--iputefieldbg-colour', color);
    this.themedataobj.inputbgcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'input' && this.CustomthemeDataarray[a].property == 'bgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'input' && this.themeDataarray[t].property == 'bgcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "input";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'bgcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'input' && this.themeDataarray[t].property == 'bgcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "input";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'bgcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "input",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }


  inputfieldbgcolorafterclick(color) {
    document.documentElement.style.setProperty('--iputefieldbgafterclick-colour', color);
  }

  inputfieldcolor(color) {
    document.documentElement.style.setProperty('--iputefield-colour', color);
    this.themedataobj.inputtxtcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'input' && this.CustomthemeDataarray[a].property == 'txtcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'input' && this.themeDataarray[t].property == 'txtcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "input";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'txtcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'input' && this.themeDataarray[t].property == 'txtcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "input";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'txtcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "input",
          "property": "txtcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }



  }

  setinputfieldwidth(color) {
    document.documentElement.style.setProperty('--iputefieldwidth-value', color);
  }

  // table section

  settableheadingbackgeound(color) {
    document.documentElement.style.setProperty('--settbheadingbg-colour', color);
    this.themedataobj.tbheadbgcolor = color;
   
    
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'table' && this.CustomthemeDataarray[a].property == 'headerbgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'headerbgcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "table";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'headerbgcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'headerbgcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "table";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'headerbgcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "table",
          "property": "headerbgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }

  settabledatabackgeound(color) {
    document.documentElement.style.setProperty('--settbdatabg-colour', color);
    this.themedataobj.tbdatabgcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'table' && this.CustomthemeDataarray[a].property == 'databgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'databgcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "table";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'databgcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'databgcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "table";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'databgcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "table",
          "property": "databgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }

  }

  settableheadingcolor(color) {
    document.documentElement.style.setProperty('--settbheading-colour', color);
    this.themedataobj.tbheadtxtcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'table' && this.CustomthemeDataarray[a].property == 'headertxtcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'headertxtcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "table";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'headertxtcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'headertxtcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "table";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'headertxtcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "table",
          "property": "headertxtcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }



  }

  settabledatacolor(color) {
    document.documentElement.style.setProperty('--settbdata-colour', color);
    this.themedataobj.tbdatatxtcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'table' && this.CustomthemeDataarray[a].property == 'datatxtcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'datatxtcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "table";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'datatxtcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'datatxtcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "table";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'datatxtcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "table",
          "property": "datatxtcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }
  settablehaederfont(color) {
    document.documentElement.style.setProperty('--settbheaderfont-value', color);
    this.themedataobj.tbheadfontsize = color;

    
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'table' && this.CustomthemeDataarray[a].property == 'headerfontsize') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'headerfontsize') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "table";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'headerfontsize';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'headerfontsize') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "table";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'headerfontsize';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "table",
          "property": "headerfontsize",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }


  settabledatafont(color) {
    document.documentElement.style.setProperty('--settbdatafont-value', color);
    this.themedataobj.tbdatafontsize = color;

    
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'table' && this.CustomthemeDataarray[a].property == 'datafontsize') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'datafontsize') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "table";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'datafontsize';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'table' && this.themeDataarray[t].property == 'datafontsize') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "table";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'datafontsize';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "table",
          "property": "datafontsize",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }



  }

  settableswidth(color) {
    document.documentElement.style.setProperty('--settbwidth-value', color);
  }
  settablesmargin(color) {
    document.documentElement.style.setProperty('--settbmargin-value', color);
  }

  settablespadding(color) {
    document.documentElement.style.setProperty('--settbpadding-value', color);
  }

  // icons

  seticonsbgcolor(color) {
    document.documentElement.style.setProperty('--seticonsbg-colour', color);
     this.themedataobj.iconsbgcolor =color;
    
     if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'icons' && this.CustomthemeDataarray[a].property == 'bgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'icons' && this.themeDataarray[t].property == 'bgcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "icons";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'bgcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'icons' && this.themeDataarray[t].property == 'bgcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "icons";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'bgcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "icons",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }
 


  }
  seticonstxtcolor(color) {
    document.documentElement.style.setProperty('--seticonstxt-colour', color);
     this.themedataobj.iconstxtcolor= color;
   
     if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'icons' && this.CustomthemeDataarray[a].property == 'txtcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'icons' && this.themeDataarray[t].property == 'txtcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "icons";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'txtcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'icons' && this.themeDataarray[t].property == 'txtcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "icons";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'txtcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "icons",
          "property": "txtcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }


  }


  setiSidebarbgcolor(color) {
    document.documentElement.style.setProperty('--setsidebarbg-colour', color);
    this.themedataobj.sidebarbgcolor = color;

    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'sidebar' && this.CustomthemeDataarray[a].property == 'bgcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'sidebar' && this.themeDataarray[t].property == 'bgcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "sidebar";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'bgcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'sidebar' && this.themeDataarray[t].property == 'bgcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "sidebar";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'bgcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "sidebar",
          "property": "bgcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }

  }
  setsidebartxtcolor(color) {
    document.documentElement.style.setProperty('--setsidebartxt-colour', color);
    this.themedataobj.sidebartxtcolor = color;
   
    if (this.themeDataarray.length > 0){
      if(this.CustomthemeDataarray.length >0){
        for (let a = 0; a <  this.CustomthemeDataarray.length; a++) {
            if(this.CustomthemeDataarray[a].fk_UserID === this.authservice.Loggeduser.userid){
              if (this.CustomthemeDataarray[a].tag == 'sidebar' && this.CustomthemeDataarray[a].property == 'txtcolor') {
               this.CustomthemeDataarray[a].value = color;
               this.CustomthemeDataarray[a].fK_CreatedById =  this.authservice.Loggeduser.userid;
               this.InsertCustomTheme.push(this.CustomthemeDataarray[a]);
               console.log('updating');
              }
             }
             else{
   
                for (let t = 0; t <  this.themeDataarray.length; t++) {
                  if (this.themeDataarray[t].tag == 'sidebar' && this.themeDataarray[t].property == 'txtcolor') {
                        this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                        this.themeDataarray[t].pK_TranId = 0;
                       this.themeDataarray[t].tag = "sidebar";
                       this.themeDataarray[t].theme = "custom";
                       this.themeDataarray[t].property = 'txtcolor';
                       this.themeDataarray[t].value = color;
                     this.InsertCustomTheme.push(this.themeDataarray[t]);
                     console.log('insering');
                  }
                  
                }
               
                
           }
          
           }
        }
       else{
        for (let t = 0; t <  this.themeDataarray.length; t++) {
          if (this.themeDataarray[t].tag == 'sidebar' && this.themeDataarray[t].property == 'txtcolor') {
                this.themeDataarray[t].fK_CreatedById = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].fk_UserID = this.authservice.Loggeduser.userid,
                this.themeDataarray[t].pK_TranId = 0;
               this.themeDataarray[t].tag = "sidebar";
               this.themeDataarray[t].theme = "custom";
               this.themeDataarray[t].property = 'txtcolor';
               this.themeDataarray[t].value = color;
             this.InsertCustomTheme.push(this.themeDataarray[t]);
             console.log('insering');
          }
          
        }
              
       }
      
       }
      else {
       var myobj = {
          "pK_TranId": 0,
          "theme": "Default",
          "fk_UserID": 1,
          "tag": "sidebar",
          "property": "txtcolor",
          "value": color,
          "isActive": true,
          "fK_CreatedById": 1,
          "createDateTime": null
        }
        this.InsertCustomTheme.push(myobj);
       }



  }

  closedialog() {
    this.dialog.closeAll();
   }

  savethemeData(){
    var result = this.InsertCustomTheme.reduce((unique, o) => {
      if (!unique.some(obj => obj.property === o.property && obj.tag === o.tag)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log('result', result);

    let boj = {
      WebTheme: result
    }
    console.log(boj);
    this.authservice.insertthemedata(boj).subscribe(data => {
      console.log('api response',data)
     
    });
    this.dialog.closeAll();

  }


}
